export const BusinessActionTypes = {
  SET_BUSINESSES: 'SET_BUSINESSES',
  SET_BUSINESS: 'SET_BUSINESS',
  SET_ORDER_METRICS: 'SET_ORDER_METRICS'
};
